module.exports = __webpack_public_path__ + "img/Installation.26a44173.svg";